import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  Tooltip,
  LineChart,
  Line,
  ResponsiveContainer,
} from 'recharts';
import StorytellerUsers from '../../../components/StorytellerUsers';
import StorytellerMessages from '../../../components/StorytellerMessages';

const barData = Array.from({ length: 30 }, (_, i) => ({
  day: i + 1,
  visitors: Math.floor(Math.random() * 400),
}));

const lineData = Array.from({ length: 30 }, (_, i) => ({
  day: i + 1,
  active: Math.floor(Math.random() * 400) + 100,
}));

export default function Dh_homeComponent () {
  return (
    <div className="min-h-screen bg-[#0e1628] text-white p-6">
      <div className="grid grid-cols-1 md:grid-cols-4 gap-4 mb-6">
        {/* <Card title="Unique Visitors" value="24.7K" change="+20%" /> */}
        <StorytellerUsers/>
        <StorytellerMessages/>
        {/* <Card title="Total Pageviews" value="55.9K" change="+4%" />
        <Card title="Bounce Rate" value="54%" change="-1.59%" isNegative />
        <Card title="Visit Duration" value="2m 56s" change="+7%" /> */}
      </div>

      <div className="bg-[#121c31] rounded-lg p-6 mb-6">
        <div className="flex justify-between items-center mb-4">
          <h3 className="text-lg font-semibold">Analytics</h3>
          <div className="space-x-2">
            <button className="px-3 py-1 bg-white text-black rounded">Monthly</button>
            <button className="px-3 py-1 text-gray-400">Quarterly</button>
            <button className="px-3 py-1 text-gray-400">Annually</button>
          </div>
        </div>
        <ResponsiveContainer width="100%" height={250}>
          <BarChart data={barData}>
            <XAxis dataKey="day" />
            <YAxis />
            <Tooltip />
            <Bar dataKey="visitors" fill="#4f46e5" radius={[4, 4, 0, 0]} />
          </BarChart>
        </ResponsiveContainer>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        <DataTable title="Top Channels" columns={["Source", "Visitors"]} data={[
          ["Google", "4.7K"],
          ["Facebook", "3.4K"],
          ["Threads", "2.9K"],
          ["Google", "1.5K"],
        ]} />

        <DataTable title="Top Pages" columns={["Source", "Pageview"]} data={[
          ["tailadmin.com", "4.7K"],
          ["preview.tailadmin.com", "3.4K"],
          ["docs.tailadmin.com", "2.9K"],
          ["tailadmin.com/components", "1.5K"],
        ]} />

        <div className="bg-[#121c31] p-6 rounded-lg">
          <h3 className="text-lg font-semibold mb-2">Active Users</h3>
          <p className="text-3xl text-red-500 font-bold mb-4">● 364 <span className="text-white text-sm">Live visitors</span></p>
          <ResponsiveContainer width="100%" height={100}>
            <LineChart data={lineData}>
              <XAxis dataKey="day" hide />
              <YAxis hide />
              <Tooltip />
              <Line type="monotone" dataKey="active" stroke="#3b82f6" strokeWidth={2} dot={false} />
            </LineChart>
          </ResponsiveContainer>
          <div className="grid grid-cols-3 text-center mt-4 text-sm">
            <div>
              <p className="text-white">224</p>
              <p className="text-gray-400">Avg. Daily</p>
            </div>
            <div>
              <p className="text-white">1.4K</p>
              <p className="text-gray-400">Avg. Weekly</p>
            </div>
            <div>
              <p className="text-white">22.1K</p>
              <p className="text-gray-400">Avg. Monthly</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

const Card = ({ title, value, change, isNegative = false }) => {
  const changeColor = isNegative ? "text-red-400" : "text-green-400";
  return (
    <div className="bg-[#121c31] p-4 rounded-lg">
      <p className="text-sm text-gray-400">{title}</p>
      <p className="text-2xl font-bold">{value}</p>
      <p className={`text-xs ${changeColor}`}>{change} Vs last month</p>
    </div>
  );
};

const DataTable = ({ title, columns, data }) => (
  <div className="bg-[#121c31] p-6 rounded-lg">
    <h3 className="text-lg font-semibold mb-4">{title}</h3>
    <div className="space-y-2">
      <div className="flex justify-between text-gray-400 text-sm font-medium mb-2">
        {columns.map((col, i) => <span key={i}>{col}</span>)}
      </div>
      {data.map((row, i) => (
        <div key={i} className="flex justify-between text-sm">
          <span>{row[0]}</span>
          <span>{row[1]}</span>
        </div>
      ))}
    </div>
    <button className="mt-4 text-sm text-blue-400 hover:underline">Channels Report →</button>
  </div>
);

